import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";
import { absUrl } from "../../lib/api";

export default function Gallery() {
  return (
    <CRUDAdmin
      title="Gallery"
      subtitle="Manage gallery items by category."
      endpoint="/admin/gallery"
      testIdPrefix="gal"
      defaults={{ active: true, order: 100, category: "weddings" }}
      columns={[
        { title: "Preview", render: r => r.image_url ? <img src={absUrl(r.image_url)} className="w-16 h-16 object-cover" alt="" /> : "—" },
        { title: "Title", key: "title" },
        { title: "Category", key: "category" },
        { title: "Order", key: "order" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "category", label: "Category (slug)" },
        { name: "order", label: "Order", type: "number" },
        { name: "image_url", label: "Image", type: "media", full: true },
        { name: "active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
